import { Box, Table, TableBody, TableContainer } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";
import Scrollbar from "../../components/scrollbar/Scrollbar";
import {
  TableHeadCustom,
  TableNoData,
  TableSkeleton,
} from "../../components/table";
import VotersTableRow from "./VotersTableRow";

const TABLE_HEAD = [
  { id: "name", label: "Name", align: "left" },
  { id: "phone", label: "Phone", align: "left" },
  { id: "email", label: "Email", align: "left" },
];

const VotedUserList = ({ data }) => {
  const fetchLoading = useSelector(
    (state) => state.fanVoice.fetchFanChoiceResults
  );

  return (
    <Box>
      <TableContainer sx={{ position: "relative", overflow: "unset" }}>
        <Scrollbar>
          <Table sx={{ minWidth: 800 }}>
            <TableHeadCustom headLabel={TABLE_HEAD} />

            <TableBody>
              {(fetchLoading ? [...Array(5)] : data)?.map((row, index) =>
                row ? (
                  <VotersTableRow key={index} row={row} />
                ) : (
                  <TableSkeleton key={index} sx={{ height: 52 }} />
                )
              )}
            </TableBody>

            {!fetchLoading && <TableNoData isNotFound={!data?.length} />}
          </Table>
        </Scrollbar>
      </TableContainer>
    </Box>
  );
};

export default VotedUserList;
